import { IProfiItemProps } from '../../../components/Profi';
import { UIHeading2, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionReload24, IconActionOpenFolderLine24, IconToggleStarOff24 } from '@cian/ui-kit-design-tokens/icons';

export const getProfiItemsConstants = (isDesktop?: boolean): IProfiItemProps[] => {
  const iconColor = isDesktop ? 'icon-secondary-default' : 'icon-positive-default';
  const TitleComponent = isDesktop ? UIHeading2 : UIHeading4;
  const DescriptionComponent = isDesktop ? UIText1 : UIText2;

  return [
    {
      icon: <IconActionOpenFolderLine24 color={iconColor} />,
      title: (
        <TitleComponent color="text-primary-default">
          С клиентами Сделки работают только наши избранные агенты
        </TitleComponent>
      ),
      description: (
        <DescriptionComponent color="text-primary-default">
          Выберем среди них самого подходящего под запрос
        </DescriptionComponent>
      ),
    },
    {
      icon: <IconActionReload24 color={iconColor} />,
      title: <TitleComponent color="text-primary-default">Если вас не устроит — подберём замену</TitleComponent>,
    },
    {
      icon: <IconToggleStarOff24 color={iconColor} />,
      title: (
        <TitleComponent color="text-primary-default">Эта задача всегда будет в приоритете для агента</TitleComponent>
      ),
    },
  ];
};
